import React from 'react';
import ReactDOM from 'react-dom';

import FileState from 'filestate/FileState';
import {isFileStateWithModel} from 'filestate/FileStateTypedefs';
import {getSubworkspaceHeaderMetadata} from 'nav/workspace/header/SubworkspaceHeaderUtil';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';

export class SubworkspaceHeaderView extends Backbone.View<Backbone.Model> {
  file: FileState | null = null;

  static initClass(): void {
    this.prototype.el = '#subworkspaceHeader';
  }

  registerListeners(): void {
    if (this.file != null) {
      this.listenTo(this.file, 'change', this.render.bind(this));
      if (isFileStateWithModel(this.file)) {
        this.listenTo(this.file.model(), 'change', this.render.bind(this));
      }
    }
  }

  removeListeners(): void {
    if (this.file != null) {
      this.stopListening(this.file);
      if (isFileStateWithModel(this.file)) {
        this.stopListening(this.file.model());
      }
    }
  }

  update(fileState: FileState | null): void {
    if (this.file !== fileState) {
      this.removeListeners();
      this.file = fileState;
      this.registerListeners();
    }
    this.render();
  }

  override render(): this {
    // If we're looking at a file (vs empty workspace)...
    if (this.file != null) {
      const maybeMetadata = getSubworkspaceHeaderMetadata(this.file);
      // ...and the file has a header registered...
      if (maybeMetadata) {
        const {HeaderComponent, propsFromFileState, suppress} = maybeMetadata;
        // ...and the display is actually enabled...
        if (!suppress) {
          // ...then render the fancy header.
          renderToDOM(<HeaderComponent {...propsFromFileState(this.file)} />, this.el);
          return this;
        }
      }
    }
    // Otherwise render empty fragment so we always have a root and can always safely clean up.
    renderToDOM(<></>, this.el);
    return this;
  }

  override remove(): Backbone.View<Backbone.Model> {
    this.removeListeners();
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}
SubworkspaceHeaderView.initClass();
